<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; padding: 16px;">
  <cs-button small secondary (click)="showSimpleAlert()" [label]="'Simple Alert' | untranslated" data-test="simple-alert-button">
  </cs-button>
  <cs-button small secondary (click)="showConfirmAlert()" [label]="'Confirm Alert' | untranslated" data-test="confirm-alert-button">
  </cs-button>
  <cs-button small secondary (click)="showRadioAlert()" [label]="'Radio Alert' | untranslated" data-test="radio-alert-button">
  </cs-button>
  <cs-button small secondary (click)="showInputAlert()" [label]="'Input Alert' | untranslated" data-test="input-alert-button">
  </cs-button>
  <cs-button small secondary (click)="showLongTextAlert()" [label]="'Long Text Alert' | untranslated" data-test="long-text-alert-button">
  </cs-button>
  <cs-button small secondary (click)="showThreeButtonAlert()" [label]="'Three Button Alert' | untranslated" data-test="three-button-alert-button">
  </cs-button>
  <cs-button small secondary (click)="showNonDismissibleAlert()" [label]="'Non-Dismissible Alert' | untranslated"
    data-test="non-dismissible-alert-button">
  </cs-button>
  <cs-button small secondary (click)="showLongButtonTextAlert()" [label]="'Long Button Text Alert' | untranslated"
    data-test="long-button-text-alert-button">
  </cs-button>
  <cs-button small secondary (click)="showExplicitlyDismissibleAlert()" [label]="'Explicitly Dismissible' | untranslated"
    data-test="dismissible-alert-button">
  </cs-button>
  <cs-button small secondary (click)="showLogDetailPopover($event)" [label]="'Log Detail Popover' | untranslated"
    data-test="log-detail-popover-button">
  </cs-button>
  <cs-button small secondary (click)="showViewNotesPopover($event)" [label]="'View Notes Popover' | untranslated"
    data-test="view-notes-popover-button">
  </cs-button>
  <cs-button small secondary (click)="annotatorRequested.emit()" [label]="'Screenshot Annotator' | untranslated"
    data-test="screenshot-annotator-button">
  </cs-button>
</div>
